export default {
	namespaced: true,
	state: {
		portfolios: [],
		order: 'rating', // rating - profit - risk
		total: 0,
		pagelen: 10,
		page: 0
	},
	getters: {
		portfolios(state) {
			return state.portfolios;
		},
		portfolio(state) {
			return (id) => { return state.portfolios.find(p => { return p.id === id; }); }
		},
		total(state) {
			return state.total;
		},
		pagelen(state) {
			return state.pagelen;
		},
		page(state) {
			return state.page;
		},
		order(state) {
			return state.order;
		}
	},
	mutations: {
		setPortfolios(state, data) {
			state.portfolios = data;
		},
		setOrder(state, data) {
			if (data === 'rating' || data === 'profit' || data === 'risk')
				state.order = data;
		},
		setPage(state, data) {
			if (data < 0) return;
			let count = Math.ceil(state.total / state.pagelen);
			if (data >= count) data = count - 1;
			state.page = data;
		},
		setTotal(state, data) {
			state.total = data;
		}
	},
	actions: {
		loadPortfolios(state) {
			setTimeout(() => {
				let count = 100;
				let allPortfolios = getPortfolios(count);
				let pagelen = state.getters.pagelen;
				let page = state.getters.page;
				let maxPages = Math.ceil(count / pagelen);

				if (page >= maxPages) page = maxPages - 1;
				orderPortfolios(allPortfolios, state.getters.order);
				//console.log(`loadPortfolios(page: ${page}, pagelen: ${pagelen}, allPortfolios: ${allPortfolios.length})`);
				let portfolios = allPortfolios.slice(page * pagelen, (page + 1) * pagelen);

				state.commit('setTotal', count);
				state.commit('setPortfolios', portfolios);
			}, 1000);
		},
		applyOrder(state, order){
			state.commit('setOrder', order);
			state.dispatch('loadPortfolios');
		},
		// begin backward forward end
		changePage(state, direction) {
			if (direction === 'begin') {
				if (state.getters.page === 0) return;
				state.commit('setPage', 0);
				state.dispatch('loadPortfolios');
				return;
			}
			if (direction === 'backward') {
				if (state.getters.page === 0) return;
				state.commit('setPage', state.getters.page - 1);
				state.dispatch('loadPortfolios');
				return;
			}

			let maxPage = Math.ceil(state.getters.total / state.getters.pagelen) - 1;
			if (direction === 'forward') {
				if (state.getters.page === maxPage) return;
				state.commit('setPage', state.getters.page + 1);
				state.dispatch('loadPortfolios');
				return;
			}
			if (direction === 'end') {
				if (state.getters.page === maxPage) return;
				state.commit('setPage', maxPage);
				state.dispatch('loadPortfolios');
				return;
			}
		}
	}
}

function orderPortfolios(portfolios, field) {
	portfolios.sort((a, b) => {
		let selector = field === 'rating' ? 'rating'
			: field === 'profit' ? 'twr' : 'drawdown';
		let va = a[selector], vb = b[selector];
		let sign = va > vb ? 1 : va < vb ? -1 : 0;
		if (selector === 'drawdown') sign = -sign;
		return -sign;
	});
}

function getPortfolios(count) {
	let result = [];
	for (let i = 0; i < count; i++)
	result.push(
		{
			id: i,
			name: `MasterForex ${i}`,
			rating: 1.5 + Math.random() * (5 - 1.5),
			currency: 'BTC',
			twr: Math.random() * 100 - 20,
			profit: 0.21 - i/30,
			sharp: 1.02 - i/50,
			sortino: 1.12 - i / 50,
			drawdown: 20.01 + i,
			term: 301,
			chart: buildChart(15)
		});
	
	return result;
}

function buildChart(count) {
	let chart = [];
	let start = 0;
	for (let i = 0; i < count; i++) {
		let step = Math.floor(Math.random() * 80) - 40;
		start += step;
		chart.push(start);
	}
	// uniform
	let min = Math.min(...chart);
	let max = Math.max(...chart);
	let k = 100 / (max - min);
	//console.log(`k: ${k}, min: ${min}, max: ${max}`);
	for (let i = 0; i < count; i++)
		chart[i] = Math.floor(k * (chart[i] - min));

	return chart;
}